import React from 'react';
import { Container, Typography, Box, Button, Paper, Card, CardContent } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { perfilAcessoService, PerfilAcessoDetalhes } from '../services/perfilAcesso';

const PerfilAcessoVisualizar: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  // Buscar dados do perfil de acesso
  const { data: perfil, isLoading, error } = useQuery({
    queryKey: ['perfilAcesso', id],
    queryFn: () => perfilAcessoService.getById(id!),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
          <Typography>Carregando...</Typography>
        </Box>
      </Container>
    );
  }

  if (error || !perfil) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
          <Typography color="error">Erro ao carregar o perfil de acesso.</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/perfis-acesso')}
          sx={{ mb: 2 }}
        >
          Voltar
        </Button>
        <Typography variant="h4" component="h1">
          Visualizar Perfil de Acesso
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Detalhes do perfil de acesso
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Dados Principais */}
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 2 }}>
                Dados Principais
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                <Box>
                  <Typography variant="body2" color="text.secondary">ID do Perfil</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{perfil.idRole}</Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">Nome do Perfil</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{perfil.role}</Typography>
                </Box>
              </Box>
            </Box>

            {/* Menus Associados */}
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 2 }}>
                Menus Associados
              </Typography>
              {perfil.menus && perfil.menus.length > 0 ? (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, gap: 2 }}>
                  {perfil.menus.map((menu) => (
                    <Box key={menu.idMenu} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                      <Typography variant="body2" color="text.secondary">
                        ID: {menu.idMenu}
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        {menu.menu}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="body1" color="text.secondary">
                  Nenhum menu associado a este perfil.
                </Typography>
              )}
            </Box>
          </Box>
        </CardContent>
      </Paper>
    </Container>
  );
};

export default PerfilAcessoVisualizar;
